import { render, staticRenderFns } from "./OrgSettingsResumeSettings.vue?vue&type=template&id=0712f0e6&scoped=true&"
import script from "./OrgSettingsResumeSettings.vue?vue&type=script&lang=js&"
export * from "./OrgSettingsResumeSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0712f0e6",
  null
  
)

export default component.exports